
    import Vue from 'vue';
    import { PropType } from 'vue';
    import { Home } from '@/apps/shared/models/home';
    import { safeRedirect } from '@/apps/shared/utils/safeRedirectHelper';
    import SettingsService from '@/apps/shared/services/getSettings-service';
    export default Vue.extend({
        name: 'Home',
        props: {
            home: {
                type: Object as PropType<Home>,
                required: true,
            },
        },
        data() {
            return {
                productSelected: null,
            }
        },
        methods: {
            async loadGoogleTagManager() {
                try {
                    // Se obtiene el ID desde Config/appsettings.json a través del backend.
                    const containerId = await SettingsService.getSettings('DefaultHomeGTMInfo:IdGTM');

                    if (!containerId || !/^GTM-[A-Z0-9]+$/.test(containerId)) {
                        return;
                    }

                    // Evita duplicar el contenedor al volver a Home.
                    const scriptId = `gtm-home-${containerId}`;
                    if (document.getElementById(scriptId) ||
                        document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${containerId}"]`)) {
                        return;
                    }

                    const gtmWindow = window as any;
                    gtmWindow.dataLayer = gtmWindow.dataLayer || [];
                    gtmWindow.dataLayer.push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js',
                    });

                    const script = document.createElement('script');
                    script.id = scriptId;
                    script.async = true;
                    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
                    document.head.appendChild(script);
                } catch (error) {
                    console.error('No se pudo cargar Google Tag Manager para Home:', error);
                }
            },
            async redirectToProduct(product: any) {
                NF.UI.Page.block();
                sessionStorage.setItem("ExitOrContinueModal", "false");
                this.productSelected = product.id;
                setTimeout(async () => {
                    await safeRedirect(product.path, null, this.$router);
                }, 100);
            },
            async pageCustomization() {
                try {
                    NF.UI.Page.block();
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                    await this.updatePageCustomization();
                }
                finally {
                    NF.UI.Page.unblock();
                }
            },
            updatePageCustomization() {
                this.Bus.$emit('showNavbar', this.home.navbar.active);
                this.Bus.$emit('updateLogo', this.home.navbar.logo);
                this.Bus.$emit('updateTitle', this.home.navbar.title);
            },
        },
        async mounted() {
            this.loadGoogleTagManager();
            await this.pageCustomization();
        },
        beforeCreate() {
            const vm = this as any;
            window.addEventListener('pageshow', function (event) {
                if (event.persisted) {
                    NF.UI.Page.unblock();
                    vm.productSelected = null;
                }
            });
        },
    });
